<div class="app-background" (click)="clickOutside($event)">
    <div *ngIf="!views.hidden">
        <ui-view></ui-view>
        <div class="display-none">
            <div id="device_token"></div>
            <div id="device_name"></div>
            <div id="distribution"></div>
            <div id="apple_token"></div>
            <div id="platform"></div>
        </div>
    </div>
    <div class='preloader bg-light-shadow' *ngIf="views.hidden">
        <div style="margin:auto;width:40px">
            <loader></loader>
        </div>
    </div>
</div>
